<template>
  <div class="panel" style="height:calc(15% - 2px)">
    <div class="navHead flex">
      <div class="cube flex">
        <div class="name">{{ zdN }}</div>
        <div>
          <span class="num">{{ zd }}</span
          ><span class="unit">（{{ unit }}）</span>
        </div>
      </div>
      <div class="xseBox flex">
        <div class="flex olineBox">
          <div class="xse">
            <div>
              <span class="num">{{ xs }}</span
              ><span class="unit">（{{ unit }}）</span>
            </div>
            <div class="name">
              <span class="pointNode" style="background:#FED405"></span>
              <span>{{ xsN }}</span>
            </div>
          </div>
          <div class="xse">
            <div>
              <span class="num">{{ xx }}</span
              ><span class="unit">（{{ unit }}）</span>
            </div>
            <div class="name">
              <span class="pointNode" style="background:#00B7EF"></span>
              <span>{{ xxN }}</span>
            </div>
          </div>
        </div>
        <div class="progess">
          <div class="progess_line" :style="{ width: widthLine }"></div>
          <div class="rotate rotate2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenV2DataProcessGetCpxse } from "@/api/home";
export default {
  data() {
    return {
      widthLine: "25%",
      widthUnLine: "75%",
      zd: "",
      zdN: "",
      xs: "",
      xsN: "",
      xx: "",
      xxN: "",
      unit: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getScreenV2DataProcessGetCpxse({ year: 2021 }).then(res => {
        let datas = res.data;
        this.unit = datas[0].unit;
        this.zd = datas[0].value;
        this.zdN = datas[0].name;
        this.xs = datas[1].value;
        this.xsN = datas[1].name;
        this.xx = datas[2].value;
        this.xxN = datas[2].name;
        this.widthLine =
          (parseFloat(this.xs) / parseFloat(this.zd)).toFixed(2) + "%";
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  font-size 0.06rem
.navHead
  height calc(100% - 2px)
  padding 0 10px
  align-items center
.cube
  width 32%
  height 80%
  text-align center
  flex-wrap wrap
  justify-content center
.xse
  width 50%
.xseBox
  flex 1
  flex-wrap wrap
  height 80%
.olineBox
  justify-content space-around
  width 100%
.progess
  background #00B7EF
  width 100%
  height 10px
  border-radius 5px
  overflow hidden
  position relative
  flex-wrap wrap
.progess_line
  height 100%
  border-radius 5px
  background #FED405
.pointNode
  display inline-block
  width 25px
  height 10px
  margin-right 5px
  border-radius 8px
.num
  font-size 0.13rem
.num, .unit
  color $textColor
.devideLine
  height 2px
  background linear-gradient(to right, transparent, #0B305C, #155782, #0B305C, transparent)
.rotate2
  background-image url('~images/index/home/xsxs.png')
  background-repeat: no-repeat;
  background-size: 100% 100%;
.rotate
  position absolute
  top 0
  left 0
  width 74px
  height 100%
  animation rotate 2.5s linear infinite
  -moz-animation rotate 2.5s linear infinite
  -webkit-animation rotate 2.5s linear infinite
  -o-animation rotate 2.5s linear infinite
@keyframes rotate
  0%
    left 0
  100%
    left 100%
@media (max-width 1280px)
    .panel
       font-size 0.08rem
    .progess
       height 8px
    .pointNode
       height 8px
</style>
